module.exports = __webpack_public_path__ + "img/Company.e0568cb3.png";